<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{returnTermsName()}}상세
        </div>
<!--        <div class="list-content">
          <div class="filter-select-div el-div-long mb11">
            <span class="filter-select-span mr20">언어</span>
            <el-select v-model="langOption" class="select mr5" :disabled="true">
              <el-option :value="''" :label="'전체'"></el-option>
              <el-option :value="language.c_idx" :label="language.c_lang_ko" v-for="language in languages"
                         :key="language.c_idx"></el-option>
            </el-select>
          </div>
        </div>-->
<!--        <terms-component :termsType="terms" :cid="type"></terms-component>-->
        <terms-component :termsType="terms" :cid="30"></terms-component>
        <div class="pa15 text-center btn_wrap">
          <el-button type="save" @click="save">저장</el-button>
          <el-button type="cancel" @click="$router.back()">목록</el-button>
        </div>
      </div>
        <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
</template>

<script>

import EventBus from "@/utils/event-bus";
import TermsComponent from "@/components/terms/TermsComponent";
import termsUtil from "@/components/terms/termsUtil";
import {appLanguage} from "@/service/languageService";

export default {
  name: "TermsDetail",
  mixins: [termsUtil],
  components: {TermsComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      terms: this.$route.params.terms,
      // type: this.$route.params.type,
      // langOption : Number(this.$route.params.type),
      //   languages: appLanguage,
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    save() {
      EventBus.$emit('writeTerms')
    },
    returnTermsName(){
      switch (this.terms){
        case 'stipulation':
          return '서비스이용약관'
      case 'privacy' :
        return '개인정보처리방침'
        case 'payment' :
          return '결제약관'
        case 'quit' :
          return '회원탈퇴약관'

      }
    }
  },
  watch: {},
}
</script>

<style lang="scss">
</style>